var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F8EBEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FCF5F5",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.84 20.6099C36.3292 20.0989 35.7228 19.6935 35.0554 19.417C34.3879 19.1404 33.6725 18.998 32.95 18.998C32.2275 18.998 31.5121 19.1404 30.8446 19.417C30.1772 19.6935 29.5708 20.0989 29.06 20.6099L28 21.6699L26.94 20.6099C25.9083 19.5782 24.509 18.9986 23.05 18.9986C21.591 18.9986 20.1917 19.5782 19.16 20.6099C18.1283 21.6416 17.5487 23.0408 17.5487 24.4999C17.5487 25.9589 18.1283 27.3582 19.16 28.3899L20.22 29.4499L28 37.2299L35.78 29.4499L36.84 28.3899C37.351 27.8791 37.7563 27.2727 38.0329 26.6052C38.3095 25.9378 38.4518 25.2224 38.4518 24.4999C38.4518 23.7774 38.3095 23.062 38.0329 22.3945C37.7563 21.7271 37.351 21.1206 36.84 20.6099V20.6099Z",
    stroke: "#BB3240",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardIcon);
export default __webpack_public_path__ + "static/media/benefitCardIcon.0a6d57e7559b1b718a3e7095284318e1.svg";
export { ForwardRef as ReactComponent };